/**
 * @flow
 * @relayHash 5f3dcd29dce98242f9baca4173cc2925
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type StudentsAdminQueryResponse = {|
  +admin: ?{| |};
|};
*/


/*
query StudentsAdminQuery(
  $count: Int!
  $cursor: String
  $hasStartedJobs: Boolean
  $hasPendingJobRequests: Boolean
  $name: String
  $email: String
) {
  admin {
    ...Students_admin_1G22uz
  }
}

fragment Students_admin_1G22uz on Admin {
  allStudents(first: $count, after: $cursor, hasStartedJobs: $hasStartedJobs, hasPendingJobRequests: $hasPendingJobRequests, name: $name, email: $email) {
    edges {
      node {
        __typename
        id
        firstname
        lastname
        pendingJobRequestsCount
        startedJobsCount
        cellphoneNumber
        user {
          email
          active
          status
          id
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasStartedJobs",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasPendingJobRequests",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "name",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "email",
        "type": "String",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentsAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Students_admin",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "StudentsAdminQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasStartedJobs",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasPendingJobRequests",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "name",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "email",
        "type": "String",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "StudentsAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "email",
                "variableName": "email",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasPendingJobRequests",
                "variableName": "hasPendingJobRequests",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasStartedJobs",
                "variableName": "hasStartedJobs",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name",
                "type": "String"
              }
            ],
            "concreteType": "StudentConnection",
            "name": "allStudents",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "StudentEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Student",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstname",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "lastname",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pendingJobRequestsCount",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "startedJobsCount",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "cellphoneNumber",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "email",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "active",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "email",
                "variableName": "email",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasPendingJobRequests",
                "variableName": "hasPendingJobRequests",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasStartedJobs",
                "variableName": "hasStartedJobs",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name",
                "type": "String"
              }
            ],
            "handle": "connection",
            "name": "allStudents",
            "key": "Students_allStudents",
            "filters": [
              "hasStartedJobs",
              "hasPendingJobRequests",
              "name",
              "email"
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query StudentsAdminQuery(\n  $count: Int!\n  $cursor: String\n  $hasStartedJobs: Boolean\n  $hasPendingJobRequests: Boolean\n  $name: String\n  $email: String\n) {\n  admin {\n    ...Students_admin_1G22uz\n  }\n}\n\nfragment Students_admin_1G22uz on Admin {\n  allStudents(first: $count, after: $cursor, hasStartedJobs: $hasStartedJobs, hasPendingJobRequests: $hasPendingJobRequests, name: $name, email: $email) {\n    edges {\n      node {\n        __typename\n        id\n        firstname\n        lastname\n        pendingJobRequestsCount\n        startedJobsCount\n        cellphoneNumber\n        user {\n          email\n          active\n          status\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/admin/student/__generated__/StudentsAdminQuery.graphql.js